import { InputBase } from "@mui/material";
import { useState } from "react";
import {
  ArrowRight,
  BadgeCheck,
  Eye,
  EyeOff,
  LockKeyhole,
  Mail,
  MapPin,
  Phone,
  User,
} from "lucide-react";

const inputSx = {
  fontSize: "14px",
  fontWeight: 700,
  color: "#0f172a",
  "& input::placeholder": {
    color: "#94a3b8",
    opacity: 1,
  },
};

const FieldShell = ({ label, required, icon: Icon, children, className }) => {
  return (
    <div className={className || ""}>
      <label className="doctor-form-label">
        {Icon ? <Icon size={14} /> : null}
        {label}
        {required ? <span>*</span> : null}
      </label>

      <div className="doctor-form-control">{children}</div>
    </div>
  );
};

const StepOnePersonal = ({ formData, setFormData, nextStep }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    setError("");
  };

  const handleNext = () => {
    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.password
    ) {
      setError("Please fill all required fields");
      return;
    }

    nextStep();
  };

  return (
    <div className="doctor-step-body">
      <div className="doctor-field-grid">
        <FieldShell label="Full name" required icon={User}>
          <InputBase
            placeholder="John Doe"
            fullWidth
            value={formData.name || ""}
            onChange={(e) => handleChange("name", e.target.value)}
            sx={inputSx}
          />
        </FieldShell>

        <FieldShell label="Email address" required icon={Mail}>
          <InputBase
            type="email"
            placeholder="doctor@example.com"
            fullWidth
            value={formData.email || ""}
            onChange={(e) => handleChange("email", e.target.value)}
            sx={inputSx}
          />
        </FieldShell>

        <FieldShell label="Phone number" required icon={Phone}>
          <InputBase
            placeholder="080XXXXXXXX"
            fullWidth
            value={formData.phone || ""}
            onChange={(e) => handleChange("phone", e.target.value)}
            sx={inputSx}
          />
        </FieldShell>

        <FieldShell label="Home address" icon={MapPin}>
          <InputBase
            placeholder="Your residential address"
            fullWidth
            value={formData.address || ""}
            onChange={(e) => handleChange("address", e.target.value)}
            sx={inputSx}
          />
        </FieldShell>

        <FieldShell label="Age" icon={BadgeCheck}>
          <InputBase
            type="number"
            placeholder="35"
            fullWidth
            value={formData.age || ""}
            onChange={(e) => handleChange("age", e.target.value)}
            sx={inputSx}
          />
        </FieldShell>

        <div>
          <label className="doctor-form-label">
            <User size={14} />
            Sex
          </label>

          <div className="doctor-form-control">
            <select
              className="doctor-native-select"
              value={formData.sex || ""}
              onChange={(e) => handleChange("sex", e.target.value)}
            >
              <option value="">Select sex</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>
        </div>

        <FieldShell
          label="Password"
          required
          icon={LockKeyhole}
          className="doctor-form-span-2"
        >
          <InputBase
            type={showPassword ? "text" : "password"}
            placeholder="Enter a secure password"
            fullWidth
            value={formData.password || ""}
            onChange={(e) => handleChange("password", e.target.value)}
            sx={inputSx}
          />

          <button
            type="button"
            onClick={() => setShowPassword((p) => !p)}
            className="doctor-icon-button"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </FieldShell>

        {/* <div className="doctor-specialist-panel doctor-form-span-2">
          <div className="doctor-specialist-head">
            <div className="doctor-specialist-title">
              <span>
                <Stethoscope size={19} />
              </span>
              <div>
                <p>Register as specialist</p>
                <small>
                  Turn this on if patients should be able to book you for a
                  specific specialty.
                </small>
              </div>
            </div>

            <button
              type="button"
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  specialist: {
                    ...prev.specialist,
                    is_specialist: !prev?.specialist?.is_specialist,
                  },
                }))
              }
              className={`doctor-switch ${
                formData?.specialist?.is_specialist ? "is-on" : ""
              }`}
              aria-label="Toggle specialist registration"
            >
              <span />
            </button>
          </div>

          {formData?.specialist?.is_specialist && (
            <div className="doctor-specialist-fields">
              <div>
                <label className="doctor-form-label">
                  <BriefcaseMedical size={14} />
                  Specialty
                </label>

                <div className="doctor-form-control">
                  <select
                    className="doctor-native-select"
                    value={formData?.specialist?.specialty || ""}
                    onChange={(e) =>
                      updateSpecialist("specialty", e.target.value)
                    }
                  >
                    <option value="">Select specialty</option>
                    <option value="Dentistry">Dentistry</option>
                    <option value="Cardiology">Cardiology</option>
                    <option value="Neurology">Neurology</option>
                    <option value="Dermatology">Dermatology</option>
                    <option value="Psychiatry">Psychiatry</option>
                  </select>
                </div>
              </div>

              <FieldShell label="Consultation fee" icon={WalletCards}>
                <span className="doctor-currency-prefix">NGN</span>

                <InputBase
                  type="number"
                  placeholder="5000"
                  fullWidth
                  value={formData?.specialist?.charge || ""}
                  onChange={(e) =>
                    updateSpecialist(
                      "charge",
                      e.target.value ? Number(e.target.value) : ""
                    )
                  }
                  sx={inputSx}
                />
              </FieldShell>
            </div>
          )}
        </div> */}
      </div>

      {error && <div className="doctor-form-error">{error}</div>}

      <button
        type="button"
        onClick={handleNext}
        className="doctor-primary-action"
      >
        Continue
        <ArrowRight size={17} />
      </button>
    </div>
  );
};

export default StepOnePersonal;
